import { CONSIDERATION_CONTENT_SLUGS } from '../../../../../ahm-constants/ui';
import { ConsiderationPageSlug } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import constants from '../../../../../ahm-constants';

type CustomSection = {
  orderIndex: number;
  productIds?: string[];
  type: string;
} & Record<string, unknown>;

const pregnancyProductSection = {
  compareButtonText: 'Compare these options',
  compareButtonToLink: constants.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
  data: {
    subtitle:
      'Compare health insurance options for pregnant women and pregnancy coverage, including hospital cover for pregnancy and birth, plus extras you might want along the way.',
    title: 'Some covers with benefits towards pregnancy and birth',
  },
  orderIndex: 2,
  productIds: [
    constants.PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750,
    constants.PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750_FAMILY_EXTRAS,
    constants.PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750_SUPER_EXTRAS,
  ],
  type: CONTENT_SECTIONS.PRODUCT_LIST,
  withBorder: true,
} satisfies CustomSection;

const youthDiscountSlider = {
  orderIndex: 2,
  type: CONTENT_SECTIONS.YOUTH_DISCOUNT_SLIDER,
} satisfies CustomSection;

const customSectionsBySlug: Partial<Record<ConsiderationPageSlug, CustomSection[]>> = {
  [CONSIDERATION_CONTENT_SLUGS.PREGNANCY_LANDING_PAGE]: [pregnancyProductSection],
  [CONSIDERATION_CONTENT_SLUGS.YOUTH_DISCOUNT_PAGE]: [youthDiscountSlider],
};

const getCustomSections = (slug: ConsiderationPageSlug) => customSectionsBySlug[slug] ?? [];

export default getCustomSections;
